import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    return (
        <div className='card mt-2'>
            <div className='card-header bg-secondary'>NOTES & COMMENTS</div>
            <div className='card-body p-0 small'>
                {IV2_PageDetails.NotesAndComments.map((Note, key) => {
                    return (
                        <div className='border p-2' key={key}>{Note.Comment}</div>
                    )
                })}
                <div className='p-0'>
                    <div className='border p-2'>{IV2_PageDetails.EventComment}</div>
                </div>
            </div>
        </div>
    )
}